import authCopy from './authCopy';
import { isValidEmail, isValidPassword, isNonEmpty } from '../helpers/validators';

const { errors } = authCopy;

export function validateEmail(email) {
    if (!isNonEmpty(email)) {
        return errors.emailRequired;
    } else if (!isValidEmail(email)) {
        return errors.emailInvalid;
    }
    return null;
}

export function validateEmailString(email) {
    if (!isNonEmpty(email)) {
        return 'Email address is required';
    } else if (!isValidEmail(email)) {
        return 'Please enter a valid email address.';
    }
    return null;
}

export function validatePassword(password) {
    if (!isNonEmpty(password)) {
        return errors.passwordRequired;
    } else if (!isValidPassword(password)) {
        return errors.passwordShort;
    }
    return null;
}

export function validatePasswordString(password) {
    if (!isNonEmpty(password)) {
        return 'Password is required.';
    } else if (!isValidPassword(password)) {
        return 'Please enter a minimum of 5 characters.';
    }
    return null;
}

export function validatePasswords(password, passwordConf) {
    let error;
    if (password !== passwordConf) {
        error = errors.passwordMatch;
    }
    return {
        password: validatePassword(password),
        passwordConf: validatePassword(passwordConf) || error,
    };
}

export function validateLogin(payload) {
    const { email = '', password = '' } = payload;
    return { email: validateEmail(email), password: validatePassword(password) };
}
